/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * Models the NewACESUAUserAccount
 *
 * @class NewACESUAUserAccount
 */
class NewACESUAUserAccount {
  /**
   * Creates an instance of NewACESUAUserAccount.
   * @param {*} json
   * @memberof NewACESUAUserAccount
   */
  constructor(json = null) {
    if (json) {
      // string
      this.firstName = json.firstName;

      // string
      this.surname = json.surname;

      // string
      this.dob = json.dob;

      // string
      this.genderType = json.genderType;

      // string
      this.emailAddress = json.emailAddress;

      // string
      this.username = json.username;

      // string
      this.password = json.password;

      // string
      this.secretQuestionType = json.secretQuestionType;

      // string
      this.secretQuestionAnswer = json.secretQuestionAnswer;

      // boolean
      this.termsAndConditionsAccepted = json.termsAndConditionsAccepted;
    }
  }
}

/**
 * Models the NewACESResetPasswordDetails
 *
 * @class NewACESResetPasswordDetails
 */
class NewACESResetPasswordDetails {
  /**
   * Creates an instance of NewACESResetPasswordDetails.
   * @param {*} json
   * @memberof NewACESResetPasswordDetails
   */
  constructor(json = null) {
    if (json) {
      // string
      this.domainNameCE = json.domainNameCE;

      // string
      this.hashToken = json.hashToken;

      // string
      this.emailAddress = json.emailAddress;

      // string
      this.new_password = json.new_password;
    }
  }
}

/**
 * Models the NewACESUserRegistrationResponseDtlsResponse
 *
 * @class NewACESUserRegistrationResponseDtlsResponse
 */
class NewACESUserRegistrationResponseDtlsResponse {
  /**
   * Creates an instance of NewACESUserRegistrationResponseDtlsResponse.
   * @param {*} json
   * @memberof NewACESUserRegistrationResponseDtlsResponse
   */
  constructor(json = null) {
    if (json) {
      // boolean
      this.isEmailNotVerified = json.isEmailNotVerified;

      // boolean
      this.isInValidEmailAddress = json.isInValidEmailAddress;

      // boolean
      this.isInValidHashToken = json.isInValidHashToken;

      // boolean
      this.isLinkExpired = json.isLinkExpired;

      // string
      this.emailAddress = json.emailAddress;

      // string
      this.username = json.username;

      // boolean
      this.isNewPasswordSameAsCurrent = json.isNewPasswordSameAsCurrent;

      // boolean
      this.isAccountLocked = json.isAccountLocked;
    }
  }
}

/**
 * Models the ACESEmailVerifiedDtls
 *
 * @class ACESEmailVerifiedDtls
 */
class ACESEmailVerifiedDtls {
  /**
   * Creates an instance of ACESEmailVerifiedDtls.
   * @param {*} json
   * @memberof ACESEmailVerifiedDtls
   */
  constructor(json = null) {
    if (json) {
      // boolean
      this.isEmailVerified = json.isEmailVerified;
    }
  }
}

/**
 * Models the NewACESHashTokenKey
 *
 * @class NewACESHashTokenKey
 */
class NewACESHashTokenKey {
  /**
   * Creates an instance of NewACESHashTokenKey.
   * @param {*} json
   * @memberof NewACESHashTokenKey
   */
  constructor(json = null) {
    if (json) {
      // string
      this.hashToken = json.hashToken;
    }
  }
}

/**
 * Models the NewACESActivationLinkEmailDetails
 *
 * @class NewACESActivationLinkEmailDetails
 */
class NewACESActivationLinkEmailDetails {
  /**
   * Creates an instance of NewACESActivationLinkEmailDetails.
   * @param {*} json
   * @memberof NewACESActivationLinkEmailDetails
   */
  constructor(json = null) {
    if (json) {
      // string
      this.username = json.username;

      // string
      this.domainNameCE = json.domainNameCE;

      // string
      this.hashToken = json.hashToken;
    }
  }
}

/**
 * Models the NewACESActivateCitizenAccountWithEmailDetails
 *
 * @class NewACESActivateCitizenAccountWithEmailDetails
 */
class NewACESActivateCitizenAccountWithEmailDetails {
  /**
   * Creates an instance of NewACESActivateCitizenAccountWithEmailDetails.
   * @param {*} json
   * @memberof NewACESActivateCitizenAccountWithEmailDetails
   */
  constructor(json = null) {
    if (json) {
      // string
      this.hashToken = json.hashToken;
    }
  }
}

/**
 * Models the NewACESAccountActivationResponseDtlsResponse
 *
 * @class NewACESAccountActivationResponseDtlsResponse
 */
class NewACESAccountActivationResponseDtlsResponse {
  /**
   * Creates an instance of NewACESAccountActivationResponseDtlsResponse.
   * @param {*} json
   * @memberof NewACESAccountActivationResponseDtlsResponse
   */
  constructor(json = null) {
    if (json) {
      // boolean
      this.isAccountAlreadyActivated = json.isAccountAlreadyActivated;

      // boolean
      this.isResendActivationLink = json.isResendActivationLink;

      // boolean
      this.isInvalidLink = json.isInvalidLink;

      // boolean
      this.isAccountActivationSuccessful = json.isAccountActivationSuccessful;
    }
  }
}

/**
 * Models the NewACESForgotUserNameDetails
 *
 * @class NewACESForgotUserNameDetails
 */
class NewACESForgotUserNameDetails {
  /**
   * Creates an instance of NewACESForgotUserNameDetails.
   * @param {*} json
   * @memberof NewACESForgotUserNameDetails
   */
  constructor(json = null) {
    if (json) {
      // string
      this.emailAddress = json.emailAddress;
    }
  }
}

/**
 * Models the NewACESAccountUnlockDetails
 *
 * @class NewACESAccountUnlockDetails
 */
class NewACESAccountUnlockDetails {
  /**
   * Creates an instance of NewACESAccountUnlockDetails.
   * @param {*} json
   * @memberof NewACESAccountUnlockDetails
   */
  constructor(json = null) {
    if (json) {
      // string
      this.emailAddress = json.emailAddress;

      // string
      this.domainNameCE = json.domainNameCE;

      // string
      this.hashToken = json.hashToken;

      // string
      this.username = json.username;
    }
  }
}

/**
 * Models the NewACESAccountUnlockResponseDtlsResponse
 *
 * @class NewACESAccountUnlockResponseDtlsResponse
 */
class NewACESAccountUnlockResponseDtlsResponse {
  /**
   * Creates an instance of NewACESAccountUnlockResponseDtlsResponse.
   * @param {*} json
   * @memberof NewACESAccountUnlockResponseDtlsResponse
   */
  constructor(json = null) {
    if (json) {
      // boolean
      this.isAccountAlreadyUnLocked = json.isAccountAlreadyUnLocked;

      // boolean
      this.isInvalidLink = json.isInvalidLink;
    }
  }
}

/**
 * Models the NewACESCheckAccountEnabled
 *
 * @class NewACESCheckAccountEnabled
 */
class NewACESCheckAccountEnabled {
  /**
   * Creates an instance of NewACESCheckAccountEnabled.
   * @param {*} json
   * @memberof NewACESCheckAccountEnabled
   */
  constructor(json = null) {
    if (json) {
      // string
      this.username = json.username;
    }
  }
}

/**
 * Models the NewACESAccountEnableResponseDtlsResponse
 *
 * @class NewACESAccountEnableResponseDtlsResponse
 */
class NewACESAccountEnableResponseDtlsResponse {
  /**
   * Creates an instance of NewACESAccountEnableResponseDtlsResponse.
   * @param {*} json
   * @memberof NewACESAccountEnableResponseDtlsResponse
   */
  constructor(json = null) {
    if (json) {
      // boolean
      this.isAccountNotActivated = json.isAccountNotActivated;

      // boolean
      this.isAccountLocked = json.isAccountLocked;
    }
  }
}

export default {
  NewACESUAUserAccount,

  NewACESResetPasswordDetails,

  NewACESUserRegistrationResponseDtlsResponse,

  ACESEmailVerifiedDtls,

  NewACESHashTokenKey,

  NewACESActivationLinkEmailDetails,

  NewACESActivateCitizenAccountWithEmailDetails,

  NewACESAccountActivationResponseDtlsResponse,

  NewACESForgotUserNameDetails,

  NewACESAccountUnlockDetails,

  NewACESAccountUnlockResponseDtlsResponse,

  NewACESCheckAccountEnabled,

  NewACESAccountEnableResponseDtlsResponse,
};
